const DEFAULT_ADMIN_LIMIT_DAYS = 5;
const MAX_CONFIGURABLE_ADMIN_DAYS = 3650;

const DEFAULTS = {
  admin: {
    verClientesAtivos: true,
    verClientesDesativos: true,
    verTodosPops: false,
    podeAtivarClientes: false,
    limiteDiasAtivacao: 5,
  },
  admin_pleno: {
    verClientesAtivos: true,
    verClientesDesativos: true,
    verTodosPops: false,
    podeAtivarClientes: true,
    limiteDiasAtivacao: DEFAULT_ADMIN_LIMIT_DAYS,
  },
  super: {
    verClientesAtivos: true,
    verClientesDesativos: true,
    verTodosPops: true,
    podeAtivarClientes: true,
    limiteDiasAtivacao: null,
  },
};

function boolValue(value, fallback) {
  if (value === undefined || value === null) return fallback;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;

  return ["1", "true", "sim", "yes"].includes(
    String(value).toLowerCase().trim()
  );
}

function limitValue(value, fallback, max = MAX_CONFIGURABLE_ADMIN_DAYS) {
  if (fallback === null && (value === undefined || value === null || value === "")) {
    return null;
  }

  const limit = Number(value || fallback);

  if (!Number.isFinite(limit)) return fallback;

  return Math.min(Math.max(limit, 1), max);
}

export function normalizeAdminPermissions(usuario = {}) {
  const tipo = usuario.tipoUsuario || "admin";
  const defaults = DEFAULTS[tipo] || DEFAULTS.admin;
  const permissoes = usuario.permissoesAdmin || {};
  const adminPleno = tipo === "admin_pleno";
  const superAdmin = tipo === "super";

  return {
    verClientesAtivos: boolValue(
      permissoes.verClientesAtivos,
      defaults.verClientesAtivos
    ),
    verClientesDesativos: boolValue(
      permissoes.verClientesDesativos,
      defaults.verClientesDesativos
    ),
    verTodosPops: boolValue(permissoes.verTodosPops, defaults.verTodosPops),
    podeAtivarClientes:
      superAdmin || adminPleno
        ? true
        : false,
    limiteDiasAtivacao: superAdmin
      ? null
      : limitValue(
          permissoes.limiteDiasAtivacao,
          defaults.limiteDiasAtivacao
        ),
  };
}

export function normalizeAdminUser(usuario = {}) {
  if (!["admin", "admin_pleno", "super"].includes(usuario.tipoUsuario)) {
    return usuario;
  }

  return {
    ...usuario,
    permissoesAdmin: normalizeAdminPermissions(usuario),
  };
}
